import React, {
  FunctionComponent,
  useEffect,
  useState,
} from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { drawerToggleStatus} from "../../Redux/actions";
import { themeColors } from "../../Components/theme";
import DarkModeSwitch from "../../Components/DarkModeSwitch/DarkModeSwitch";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import Popover from "@mui/material/Popover";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PolicyIcon from "@mui/icons-material/Policy";
import InfoIcon from "@mui/icons-material/Info";
import { auth } from "../../Firebase";
import { useHistory } from "react-router";

type props = {
  props?: any;
  title:
  | "Organizations"
  | "Contacts"
  | "Users"
  | "Drilldown"
  | "Team";
  path: string;
  leadManger: Boolean;
  project?: string;
  task?: string;
  resources?: string;
  callLogs?: string;
  faq?: string;
  user: any;
  api?: string;
  news?: string;
  apiData?: string;
  leadDistributor?: string;
  customButton?: string;
  theme: any;
  userRole: any;
  open?: boolean;
  contacts: {
    data: any;
  };
  onDrawerToggle?: () => void;
  isMobile?: boolean;
};

const Navbar: FunctionComponent<props> = ({
  props,
  title,
  path,
  leadManger,
  project,
  task,
  resources,
  callLogs,
  faq,
  user,
  api,
  news,
  apiData,
  leadDistributor,
  customButton,
  theme,
  userRole,
  open,
  contacts,
  onDrawerToggle,
  isMobile,
}) => {
  const [showUserDetail, setShowUserDetails] = useState(false);
  const [expand, setExpand] = useState(false);
  const [settingsAnchorEl, setSettingsAnchorEl] = useState<null | HTMLElement>(null);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    let timeOut: any;
    if (showUserDetail === true) {
      setExpand(true);
      document.body.style.overflowX = "hidden";
      timeOut = setTimeout(() => {
        document.body.style.overflowX = "auto";
      }, 300);
    }
    return () => clearTimeout(timeOut);
  }, [showUserDetail]);

  useEffect(() => {
    let timeOut: any;
    if (expand === false) {
      document.body.style.overflowX = "hidden";
      timeOut = setTimeout(() => {
        setShowUserDetails(false);
        document.body.style.overflowX = "auto";
      }, 300);
    }
    return () => clearTimeout(timeOut);
  }, [expand]);

  const handleDrawerToggle = () => {
    dispatch(drawerToggleStatus(!open));
  };

  const handleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen?.();
    } else {
      document.exitFullscreen?.();
    }
  };

  const handleProfileIconClick = (event: React.MouseEvent<HTMLElement>) => {
    setSettingsAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setSettingsAnchorEl(null);
  };

  const handleLogout = async() => {
   handlePopoverClose();
   Object.keys(contacts.data).forEach((key) => {
        contacts.data[key] = [];
      });
      localStorage.clear();
      sessionStorage.clear();
      clearFacebookSessionCookies();
      await auth.signOut();
      history.replace("/", {});
  };

  const handleProfile = () => {
    handlePopoverClose();
    history.push("/profile");
  };  

  const handlePrivacyPolicy = () => {
    handlePopoverClose();
    history.push("/privacy-policy");
  };

  const handleAboutUs = () => {
    handlePopoverClose();
    history.push("/about-us");
  };

  const clearFacebookSessionCookies = () => {
    try {
      const expirationDate = new Date(0).toUTCString();
      document.cookie = `fr=; expires=${expirationDate}; path=/; domain=.facebook.com`;
      document.cookie = `xs=; expires=${expirationDate}; path=/; domain=.facebook.com`;
      document.cookie = `fbsr=; expires=${expirationDate}; path=/; domain=.facebook.com`;
    } catch (error) {
      console.error("Error clearing Facebook cookies:", error);
    }
  };

  const iconColor = theme ? themeColors.navbarBackgroundColor : themeColors.iconColorDark;
  const popoverOpen = Boolean(settingsAnchorEl);
  const popoverId = popoverOpen ? 'profile-popover' : undefined;

  return (
    <AppBar
      position="fixed"
      color="default"
      elevation={2}
      sx={{
        background: theme
          ? "rgb(255, 250, 250)"
          : themeColors.cardBackgroundColorDark,
        minHeight: "53px",
        width: open ? `calc(100% - 220px)` : `calc(100% - 70px)`,
        left: open ? "220px" : "70px",
        zIndex: 100,
        ...(isMobile && { width: '100%', left: 0 })
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          minHeight: "53px !important",
          height: "53px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", marginLeft: "-20px" }}>
          {/* Hamburger icon for mobile */}
          {isMobile ? (
            <IconButton onClick={onDrawerToggle}>
              <MenuIcon
                sx={{
                  color: iconColor,
                  cursor: "pointer",
                }}
              />
            </IconButton>
          ) : (
            <IconButton onClick={handleDrawerToggle}>
              <MenuIcon
                sx={{
                  color: iconColor,
                  cursor: "pointer",
                }}
              />
            </IconButton>
          )}
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {title !== "Drilldown" && (
            <>
              <Typography variant="body2" sx={{ color: iconColor, fontWeight: 600,fontSize:"12px"}}>
                {/* {`${user.user_first_name} ${user.user_last_name}`} {user.profile ? `- ${user.profile}` : ''} {`- ${user.user_email}`} */}
                {`${user.user_first_name} ${user.user_last_name}`} {user.profile ? `- ${user.profile}` : ''}
              </Typography>
              <IconButton>
                <DarkModeSwitch />
              </IconButton>
            </>
          )}
          <IconButton sx={{ padding: "0px !important" }} onClick={handleFullscreen}>
            <FullscreenIcon sx={{ color: iconColor }} />
          </IconButton>
          <IconButton
            sx={{ padding: "0px !important" }}
            aria-describedby={popoverId}
            onClick={handleProfileIconClick}
          >
            <AccountCircleIcon sx={{ color: iconColor }} />
          </IconButton>
          <Popover
            id={popoverId}
            open={popoverOpen}
            anchorEl={settingsAnchorEl}
            onClose={handlePopoverClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            PaperProps={{
              sx: {
                borderRadius: 3,
                boxShadow: 6,
                minWidth: 150,
                p: 0,
                mt: 1,
                background: "#fff",
              }
            }}
          >
            <List sx={{ p: 0 }}>
              <ListItem
                button
                onClick={() => { handleProfile(); handlePopoverClose(); }}
                sx={{
                  py: 1,
                  px: 1.5,
                  color: "#272944",
                  fontFamily:"Poppins",
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: 36, ml: 1, color: "#272944" }}>
                  <AccountCircleIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary="My Profile"
                  primaryTypographyProps={{ fontSize: 12, fontWeight: 600, color: "#272944" }}
                />
              </ListItem>
              <Divider />
              <Divider />
              <Divider />
               <ListItem
                button
                onClick={() => { handlePrivacyPolicy(); handlePopoverClose(); }}
                sx={{
                  py: 1,
                  px: 1.5,
                  color: "#272944",
                  fontFamily:"Poppins",
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: 36, ml: 1, color: "#272944" }}>
                  <PolicyIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary="Privacy Policy"
                  primaryTypographyProps={{ fontSize: 12, fontWeight: 600, color: "#272944" }}
                />
              </ListItem>
              <Divider />
              <Divider />
              <Divider />
              {/* Add About Us below Privacy Policy */}
              <ListItem
                button
                onClick={() => { handleAboutUs(); handlePopoverClose(); }}
                sx={{
                  py: 1,
                  px: 1.5,
                  color: "#272944",
                  fontFamily:"Poppins",
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: 36, ml: 1, color: "#272944" }}>
                  <InfoIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary="About Us"
                  primaryTypographyProps={{ fontSize: 12, fontWeight: 600, color: "#272944" }}
                />
              </ListItem>
              <Divider />
              <Divider />
              <Divider />
              <ListItem
                button
                onClick={() => { handleLogout(); handlePopoverClose(); }}
                sx={{
                  py: 1,
                  px: 1.5,
                  color: "#272944",
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: 36, ml: 1, color: "#272944" }}>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary="Log Out"
                  primaryTypographyProps={{ fontSize: 12, fontWeight: 600, color: "#272944" }}
                />
              </ListItem>
            </List>
          </Popover>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
    userRole: state.user.role,
    contacts: state.contacts
  };
};

export default connect(mapStateToProps)(Navbar);
